import {
  GridCellProps,
  GridColumn
} from '@progress/kendo-react-grid';
import {
  FilterBarMainGrid,
  DateCell,
  FileDownloadCell,
  getFormattedDisplayCell,
} from 'Components/Grid';
import {
  GridProvider,
  ModalFormProvider,
  useEntity,
  useGridState
} from 'Context';
import {
  ActionsDropdownConfig,
  defaultGridProps,
  GridColumnWidth,
} from 'Models';
import {
  Permission
} from 'Models/Templates/Permission/Permission';
import {
  ENDPOINTS
} from 'Models/Templates/Routes/Routes';
import React, {
  Fragment, useState
} from 'react';
import { AppointmentIdGridSearchModel, AppointmentLetterModal, AppointmentLetterModel } from 'Models/AppointmentLetterModel';
import { AppointmentLetterDrawerForm } from './AppointmentLetterDrawerForm';
import { AppointmentLetterActionCell } from './AppointmentLetterActionCell';
import DownloadIcon from 'Assets/Icons/download.svg';

export const AppointmentLetterList: React.FC = () => {
  const entity = useEntity();

  return (
    <Fragment>
      <GridProvider entityName="Appointment Letter">
        <AppointmentLetterModalFormWrapper />
      </GridProvider>
    </Fragment>
  );
};

const AppointmentLetterModalFormWrapper: React.FC = () => {
  const entity = useEntity();

  var formModel = new AppointmentLetterModel(
    entity.appointment?.id
  );

  return (
    <ModalFormProvider
      formModel={formModel}
      endpoint={ENDPOINTS.appointmentletters.base}
    >
      <AppointmentLetterGridWithModalDrawer />
    </ModalFormProvider>
  );
};

const AppointmentLetterGridWithModalDrawer: React.FC = () => {
  const entity = useEntity();
  const [searchModel, setSearchModel] = useState(new AppointmentIdGridSearchModel(entity.appointment?.id))
  const { refreshGrid } = useGridState();


  var formModel = new AppointmentLetterModel(
    entity.appointment?.id
  );

  const actionsConfig: ActionsDropdownConfig = {
    name: 'Actions',
    items: [
      {
        name: 'Upload Letters',
        permissions: [Permission.AddAppointmentDocument],
        modalConfig: {
          modalId: AppointmentLetterModal.Attachments,
          modalComponent: (
            <AppointmentLetterDrawerForm
              endpoint={ENDPOINTS.appointmentletters.base}
              formModel={formModel}
            />
          ),
        },
      }
    ],
  };

  return (
    <Fragment>
      <FilterBarMainGrid
        headerDisabled
        isMainGrid
        headerTitle="Letters"
        filterBarProps={{
          filterConfigurations: [],
          filterValues: {},
          isColumnSelectorEnabled: false,
        }}
        readEndpoint={ENDPOINTS.appointmentletters.read}
        enableGridRefresh={true}
        search={searchModel}
        {...defaultGridProps}
        style={{ cursor: 'pointer' }}
        pageSize={25}
      >
        <GridColumn
          field="fileName"
          title="File Name"
          width={GridColumnWidth.MedLarge}
          cell={fileNameWithoutExtensionCell}
        />
        <GridColumn
          field="extension"
          title="File Format"
          width={GridColumnWidth.MedLarge}
          cell={extensionCell}
          sortable={false}
        />
        <GridColumn
          field="size"
          title="File Size"
          cell={getFormattedDisplayCell('fileSizeDisplay')}
        />
        <GridColumn
          field="uploadDate"
          title="Date & Time Uploaded"
          cell={DateTimeColumn}
        />
        <GridColumn
          field='id'
          title='Actions'
          cell={ActionsCell}
          width='150px'
        />
        <GridColumn
          field="id"
          title=" "
          cell={(props: GridCellProps) => (
            <AppointmentLetterActionCell {...props} />
          )}
          width={GridColumnWidth.Ellipsis}
        />
      </FilterBarMainGrid>
    </Fragment>
  );
};

const ActionsCell: React.FC<GridCellProps> = (props: GridCellProps) => {
  return (
    <FileDownloadCell
      fileControllerEndpoint={ENDPOINTS.appointmentletters.base}
      {...props}
    >
      <img src={DownloadIcon} alt="downloadIcon" />
    </FileDownloadCell>
  );
};

const DateTimeColumn: React.FC<GridCellProps> = (props: GridCellProps) => {
  return <DateCell {...props} dateFormat={'MM/DD/YYYY hh:mm A'} />;
};

const extensionCell: React.FC<GridCellProps> = (props: GridCellProps) => {
  const { dataItem } = props;
  const extension = dataItem?.extension || '';
  const displayValue = extension.replace('.', '').toUpperCase();

  return (
    <td className={props.className}>
      {displayValue}
    </td>
  );
}

const fileNameWithoutExtensionCell: React.FC<GridCellProps> = (props: GridCellProps) => {
  const { dataItem } = props;
  const fileName = dataItem?.fileName || '';
  const displayValue = fileName.replace(/\.[^/.]+$/, '');

  return (
    <td className={props.className}>
      {displayValue}
    </td>
  );
};